function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { resetComponent, textEllipsis } from '../../style';
import { initMoveMotion, initSlideMotion, slideDownIn, slideDownOut, slideUpIn, slideUpOut } from '../../style/motion';

var genItemStyle = function genItemStyle(token) {
  var controlPaddingHorizontal = token.controlPaddingHorizontal,
      controlHeight = token.controlHeight,
      fontSize = token.fontSize,
      lineHeight = token.lineHeight;
  return {
    position: 'relative',
    display: 'block',
    minHeight: controlHeight,
    padding: "".concat((controlHeight - fontSize * lineHeight) / 2, "px ").concat(controlPaddingHorizontal, "px"),
    color: token.colorText,
    fontWeight: 'normal',
    fontSize: fontSize,
    lineHeight: lineHeight,
    boxSizing: 'border-box'
  };
};

var genSingleStyle = function genSingleStyle(token) {
  var _disabled, _option, _Object$assign;

  var antCls = token.antCls,
      componentCls = token.componentCls;
  var selectItemCls = "".concat(componentCls, "-item");
  var slideUpEnterActive = "&".concat(antCls, "-slide-up-enter").concat(antCls, "-slide-up-enter-active");
  var slideUpAppearActive = "&".concat(antCls, "-slide-up-appear").concat(antCls, "-slide-up-appear-active");
  var slideUpLeaveActive = "&".concat(antCls, "-slide-up-leave").concat(antCls, "-slide-up-leave-active");
  var dropdownPlacementCls = "".concat(componentCls, "-dropdown-placement-");
  return [_defineProperty({}, "".concat(componentCls, "-dropdown"), Object.assign(Object.assign({}, resetComponent(token)), (_Object$assign = {
    position: 'absolute',
    top: -9999,
    zIndex: token.zIndexPopup,
    boxSizing: 'border-box',
    padding: token.paddingXXS,
    overflow: 'hidden',
    fontSize: token.fontSize,
    // Fix select render lag of long text in chrome
    // https://github.com/ant-design/ant-design/issues/11456
    // https://github.com/ant-design/ant-design/issues/11843
    fontVariant: 'initial',
    backgroundColor: token.colorBgElevated,
    borderRadius: token.borderRadiusLG,
    outline: 'none',
    boxShadow: token.boxShadowSecondary
  }, _defineProperty(_Object$assign, "\n          ".concat(slideUpEnterActive).concat(dropdownPlacementCls, "bottomLeft,\n          ").concat(slideUpAppearActive).concat(dropdownPlacementCls, "bottomLeft\n        "), {
    animationName: slideUpIn
  }), _defineProperty(_Object$assign, "\n          ".concat(slideUpEnterActive).concat(dropdownPlacementCls, "topLeft,\n          ").concat(slideUpAppearActive).concat(dropdownPlacementCls, "topLeft,\n          ").concat(slideUpEnterActive).concat(dropdownPlacementCls, "topRight,\n          ").concat(slideUpAppearActive).concat(dropdownPlacementCls, "topRight\n        "), {
    animationName: slideDownIn
  }), _defineProperty(_Object$assign, "".concat(slideUpLeaveActive).concat(dropdownPlacementCls, "bottomLeft"), {
    animationName: slideUpOut
  }), _defineProperty(_Object$assign, "\n          ".concat(slideUpLeaveActive).concat(dropdownPlacementCls, "topLeft,\n          ").concat(slideUpLeaveActive).concat(dropdownPlacementCls, "topRight\n        "), {
    animationName: slideDownOut
  }), _defineProperty(_Object$assign, '&-hidden', {
    display: 'none'
  }), _defineProperty(_Object$assign, "".concat(selectItemCls), Object.assign(Object.assign({}, genItemStyle(token)), {
    cursor: 'pointer',
    transition: "background ".concat(token.motionDurationSlow, " ease"),
    borderRadius: token.borderRadiusSM,
    // =========== Group ============
    '&-group': {
      color: token.colorTextDescription,
      fontSize: token.fontSizeSM,
      cursor: 'default'
    },
    // =========== Option ===========
    '&-option': (_option = {
      display: 'flex',
      '&-content': Object.assign({
        flex: 'auto'
      }, textEllipsis),
      '&-state': {
        flex: 'none',
        display: 'flex',
        alignItems: 'center'
      }
    }, _defineProperty(_option, "&-active:not(".concat(selectItemCls, "-option-disabled)"), {
      backgroundColor: token.controlItemBgHover
    }), _defineProperty(_option, "&-selected:not(".concat(selectItemCls, "-option-disabled)"), _defineProperty({
      color: token.colorText,
      fontWeight: token.fontWeightStrong,
      backgroundColor: token.controlItemBgActive
    }, "".concat(selectItemCls, "-option-state"), {
      color: token.colorPrimary
    })), _defineProperty(_option, '&-disabled', (_disabled = {}, _defineProperty(_disabled, "&".concat(selectItemCls, "-option-selected"), {
      backgroundColor: token.colorBgContainerDisabled
    }), _defineProperty(_disabled, "color", token.colorTextDisabled), _defineProperty(_disabled, "cursor", 'not-allowed'), _disabled)), _defineProperty(_option, '&-grouped', {
      paddingInlineStart: token.controlPaddingHorizontal * 2
    }), _option)
  })), _defineProperty(_Object$assign, '&-rtl', {
    direction: 'rtl'
  }), _Object$assign))), // Follow code may reuse in other components
  initSlideMotion(token, 'slide-up'), initSlideMotion(token, 'slide-down'), initMoveMotion(token, 'move-up'), initMoveMotion(token, 'move-down')];
};

export default genSingleStyle;